/**
 * Baby Shower Dulce Recuerdo — FUENTE ÚNICA DE PRECIOS.
 * Todos los precios de la landing salen de este archivo.
 * El checkout (ImpulTienda) se configura aparte: verificá que cobre `offerPrice`.
 */

/** Importes en pesos argentinos, sin puntos. */
export const pricing = {
  /** Precio de lista de referencia del producto principal */
  listPrice: 39990,
  /** Precio final que se paga en el checkout */
  offerPrice: 16990,
  /** Precio individual de referencia de cada bono (incluidos sin cargo en el pack) */
  bonuses: {
    dinamicas: 18990,
    guia: 16990,
    planes: 17990,
    checklist: 14990,
  },
} as const

/**
 * Interruptores comerciales. Activalos solo si corresponden a condiciones reales:
 * - showListPrice: el precio de lista tachado es una referencia comercial auténtica.
 * - showDiscountBadge: muestra el % de reducción calculado.
 * - showBonusPrices: los bonos se venden realmente por separado a esos importes.
 * - showFreeToday: los bonos están incluidos sin costo en la oferta vigente.
 * - showBundleReferenceValue: muestra el valor total de referencia del conjunto
 *   (solo válido si todos los ítems se venden por separado a esos importes).
 */
export const pricingFlags = {
  showListPrice: true,
  showDiscountBadge: true,
  showBonusPrices: true,
  showFreeToday: true,
  showBundleReferenceValue: true,
}

export type BonusKey = keyof typeof pricing.bonuses

/** $39.990 */
export function formatArs(value: number) {
  return `$${value.toLocaleString('es-AR')}`
}

/** Porcentaje de reducción del producto principal (≈58%). */
export const discountPercent = Math.round((1 - pricing.offerPrice / pricing.listPrice) * 100)

/** Suma de los bonos ($68.960). */
export const bonusesTotal = Object.values(pricing.bonuses).reduce((sum, v) => sum + v, 0)

/** Valor total de referencia del conjunto ($108.950). No es lo que se cobra. */
export const bundleReferenceValue = pricing.listPrice + bonusesTotal

/** Ahorro frente al valor total del conjunto (≈84%). */
export const bundleDiscountPercent = Math.round((1 - pricing.offerPrice / bundleReferenceValue) * 100)
